import { SKILLS } from "./profileData";
import { withDefaults } from "@/lib/sections";

export const SkillsGrid = ({ lang, content }) => (
  <section className="py-12" data-testid="skills-section">
    <p className="font-mono text-xs uppercase tracking-widest text-slate-500">// tech stack</p>
    <h2 className="mt-2 text-base font-semibold text-white md:text-lg" data-testid="skills-title">{withDefaults("p_skills", content)[`title_${lang}`]}</h2>
    <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {SKILLS.map((s, i) => (
        <div
          key={s.group.en}
          className="rounded-xl border border-white/10 bg-white/[0.03] p-5 transition-colors duration-300 hover:border-[#FF5500]/50"
          data-testid={`skill-card-${i}`}
        >
          <p className="font-mono text-sm text-[#FF5500]">{s.group[lang]}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {s.items.map((it) => (
              <span key={it} className="rounded-md bg-[#0b2240] px-2.5 py-1 font-mono text-xs text-slate-300">
                {it}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default SkillsGrid;
